import { useContext } from 'react';
import Context from './Context';

/**
 * @name useTheme
 * @description theme methods
 */
export function useTheme() {
  const context = useContext(Context);

  if (!context) {
    throw new Error('useTheme must be used within a Theme provider');
  }

  return context;
}
